import '../../../core/components/app-root/AppRoot.css';
import '../DataTable.css';
import './Alignment.css';
import '../features/ColumnOrder/ColumnOrder.css';
import '../features/Thresholds/Thresholds.css';
import './DataTableHeaderCell.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var childHeader = '_11pvd3zc-3-12-1';
export var columnSizingHandle = _7a468({defaultClassName:'_11pvd3zl-3-12-1',variantClassNames:{active:{true:'_11pvd3zm-3-12-1',false:'_11pvd3zn-3-12-1'},last:{true:'_11pvd3zo-3-12-1',false:'_11pvd3zp-3-12-1'},pinnedColumn:{false:'_11pvd3zq-3-12-1',left:'_11pvd3zr-3-12-1',right:'_11pvd3zs-3-12-1'}},defaultVariants:{},compoundVariants:[]});
export var customHeaderDensity = {'default':'_11pvd3z6-3-12-1',condensed:'_11pvd3z7-3-12-1',comfortable:'_11pvd3z8-3-12-1'};
export var firstColumn = '_11pvd3zd-3-12-1';
export var firstHeaderRow = '_11pvd3z9-3-12-1';
export var firstRightPinnedColumn = '_11pvd3zg-3-12-1';
export var firstUnpinnedColumn = '_11pvd3zf-3-12-1';
export var headerCell = _7a468({defaultClassName:'_11pvd3zt-3-12-1',variantClassNames:{pinnedColumn:{false:'_11pvd3zu-3-12-1',left:'_11pvd3zv-3-12-1',right:'_11pvd3zw-3-12-1'},rowDensity:{customHeaderRenderer:'_11pvd3zx-3-12-1','default':'_11pvd3zy-3-12-1',condensed:'_11pvd3zz-3-12-1',comfortable:'_11pvd3z10-3-12-1'},verticalDividers:{true:'_11pvd3z11-3-12-1',false:'_11pvd3z12-3-12-1'},isDragAndDropDisabled:{true:'_11pvd3z13-3-12-1',false:'_11pvd3z14-3-12-1'}},defaultVariants:{rowDensity:'default',verticalDividers:false},compoundVariants:[]});
export var headerCellActiveInteraction = '_11pvd3z16-3-12-1';
export var headerCellEllipsis = '_11pvd3z15-3-12-1';
export var headerWidthVar = 'var(--_11pvd3zj-3-12-1)';
export var hovered = '_11pvd3z0-3-12-1';
export var isMultiSortedHeader = '_11pvd3z4-3-12-1';
export var isSortedHeader = '_11pvd3z3-3-12-1';
export var lastHeaderRow = '_11pvd3za-3-12-1';
export var lastLeftPinnedColumn = '_11pvd3ze-3-12-1';
export var leftAdditionalElevationVar = 'var(--_11pvd3zk-3-12-1)';
export var leftPositionVar = 'var(--_11pvd3zh-3-12-1)';
export var narrow = '_11pvd3z1-3-12-1';
export var parentHeader = '_11pvd3zb-3-12-1';
export var rightPositionVar = 'var(--_11pvd3zi-3-12-1)';
export var sortableHeader = '_11pvd3z2-3-12-1';
export var subRowIndicatorColumn = '_11pvd3z5-3-12-1';